// F-71: keeps the chat dock clear of what a customer taps or types in.
// - It rises above the mobile follow-along cart bar while that bar shows. While the homepage scroll story's
//   stage covers the dock's corner, it rises by one constant amount: 16px above where the story's bottom bar
//   (the Discover row) rests once the stage is pinned, read from layout offsets that ignore the rugs' sliding,
//   so rug changes never move it. It never rises past the middle of the screen.
// - It fades out while it would still cover a button or form field (Add to cart, Subscribe, checkout, Shopify's
//   wallet buttons, the film controls), a Discover link (one leaving in a rug change, or one scrolling past),
//   the opening film's scroll cue, the pile-light hint or the footer's last row (Privacy and Terms), or, on the cart
//   page, the cart summary block (F-92: Original price, the discount, Total, the tax note, Check out).
//   Text and pictures pass under it. Keyboard focus inside the dock keeps it shown.
// - F-134: a photo that is a button (the product gallery's photos and thumbnails, a customer photo tile) passes
//   under it like any picture, so the dock stays in sight over a rug's first screen; it fades for the Contact
//   page's own Messenger and Instagram buttons.
(() => {
  const dock = document.querySelector('[data-es-chat-dock]');
  if (!dock) return;
  const RISE_ABOVE = '.es-sticky-buy[data-visible="true"]';
  const STORY = 'elmsett-scroll-story[data-enhanced] [data-stage]';
  const FADE_FOR = '.es-pay-in-4 iframe,button:not(.product__media-toggle,.thumbnail,.es-cp-row__tile),.es-contact__chat a,input:not([type=hidden]),select,textarea,.shopify-payment-button,shopify-accelerated-checkout,shopify-accelerated-checkout-cart,.additional-checkout-buttons,.es-ss__link,.es-film-toggle,.es-film-scroll,.es-closing-film__toggle,.es-pl__hint,.es-footer-bottom,#main-cart-footer .cart__blocks,.es-fit-entry,.es-rug-card,.es-sample__order,.es-pay-option,.es-lowstock__button,a[href$="size-guide#find-your-fit"]';
  const GAP = 8;
  const SPACE = 16;
  let queued = false, again = false;
  const overlaps = (a, b) => a.left < b.right + GAP && a.right + GAP > b.left && a.top < b.bottom + GAP && a.bottom + GAP > b.top;
  const shown = (el) => {
    const s = getComputedStyle(el);
    return s.display !== 'none' && s.visibility !== 'hidden';
  };
  // Where a fixed element rests, ignoring its transform: the cart bar slides in with one and the dock rises with one.
  const resting = (el) => {
    if (getComputedStyle(el).position !== 'fixed') return el.getBoundingClientRect();
    const left = el.offsetLeft, top = el.offsetTop;
    return { left, top, right: left + el.offsetWidth, bottom: top + el.offsetHeight, width: el.offsetWidth, height: el.offsetHeight };
  };
  // One rise per story: where each rug's bottom bar rests while the stage is pinned (the rug fills the stage, the
  // bar sits in it; offsets ignore the rugs' transforms). Applies while the stage reaches over the dock's top edge.
  const storyRise = (base) => {
    let rise = 0;
    for (const stage of document.querySelectorAll(STORY)) {
      const s = stage.getBoundingClientRect();
      if (s.top > base.top || s.bottom <= base.top) continue;
      const pinned = parseFloat(getComputedStyle(stage).top) || 0;
      for (const bar of stage.querySelectorAll('.es-ss__bar')) {
        const rug = bar.offsetParent;
        if (!rug || rug.offsetParent !== stage || !bar.offsetHeight) continue;
        const top = pinned + rug.offsetTop + bar.offsetTop, left = s.left + rug.offsetLeft + bar.offsetLeft;
        const r = { left, top, right: left + bar.offsetWidth, bottom: top + bar.offsetHeight };
        if (overlaps(base, r)) rise = Math.max(rise, base.bottom - r.top + SPACE);
      }
    }
    return rise;
  };
  // Everything is read first and written once at the end, so a frame costs one style pass. After a scroll it runs
  // once more on the next frame: the story may move its rugs in the same frame, after this has read them.
  const update = () => {
    queued = false;
    const base = resting(dock);
    let rise = storyRise(base);
    for (const el of document.querySelectorAll(RISE_ABOVE)) {
      if (!shown(el)) continue;
      const r = resting(el);
      if (r.width > 0 && r.height > 0 && overlaps(base, r)) rise = Math.max(rise, base.bottom - r.top + SPACE);
    }
    let blocked = false;
    if (base.top - rise < innerHeight / 2) {
      rise = 0;
      blocked = true;
    }
    const box = { left: base.left, right: base.right, top: base.top - rise, bottom: base.bottom - rise };
    const covered = blocked || [...document.querySelectorAll(FADE_FOR)].some((el) => {
      if (dock.contains(el)) return false;
      const r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0 && overlaps(box, r) && shown(el);
    });
    dock.style.setProperty('--es-chat-dock-rise', `${Math.round(rise)}px`);
    dock.toggleAttribute('data-stepped-aside', covered);
    if (again) {
      again = false;
      queue();
    }
  };
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  };
  const scrolled = () => {
    again = true;
    queue();
  };
  addEventListener('scroll', scrolled, { passive: true });
  addEventListener('resize', queue);
  addEventListener('load', queue);
  new ResizeObserver(queue).observe(document.body);
  new MutationObserver(queue).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['data-visible', 'hidden', 'data-enhanced'] });
  queue();
})();
